import React, { useEffect, useState } from "react";

import { useScrollLock } from "../../hooks/useScrollLock";

import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalTitle,
  NoticeList,
  NoticeItem,
  FooterText,
  NoticeText,
  TitleContainer,
} from "./TermsModal.styles";

import { ReactComponent as LogoSvg } from "../../assets/icons/fullLogo.svg";
import Button from "../utils/Button/Button";

const TermsModal = ({ isOpen, onClose }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  useScrollLock(shouldRender);

  // Kontrola renderovanja i animacije
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      setIsAnimating(false); // Početno stanje bez animacije
      // Kratka pauza da se modal renderuje pre animacije
      const timer = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsAnimating(true);
        });
      });
      return () => cancelAnimationFrame(timer);
    } else if (shouldRender) {
      setIsAnimating(false);
      // Čeka da se animacija završi pre uklanjanja iz DOM-a
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // 300ms koliko traje animacija

      return () => clearTimeout(timer);
    }
  }, [isOpen, shouldRender]);

  if (!shouldRender) return null;

  const handleContinue = () => {
    onClose();
  };

  return (
    <ModalOverlay $isAnimating={isAnimating}>
      <ModalContainer $isAnimating={isAnimating}>
        <ModalContent>
          <TitleContainer>
            <ModalTitle>Welcome</ModalTitle>
            <LogoSvg />
          </TitleContainer>
          <NoticeList>
            <NoticeItem>
              <NoticeText>🔞</NoticeText>

              <NoticeText>You must be 18+ to use this website.</NoticeText>
            </NoticeItem>
            <NoticeItem>
              <NoticeText>📌</NoticeText>

              <NoticeText>
                You can’t use others people’s photos without their permission.
              </NoticeText>
            </NoticeItem>
            <NoticeItem>
              <NoticeText>🧑‍⚖️</NoticeText>

              <NoticeText>
                You are solely responsible for the videos and images you
                generate.
              </NoticeText>
            </NoticeItem>
          </NoticeList>

          <FooterText>
            By continuing to use, you agree to the rules above.
          </FooterText>

          <Button
            onClick={handleContinue}
            title={"Continue"}
            style={{ width: 180, alignSelf: "center" }}
          />
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default TermsModal;
